@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/transcript-subtitles-panel/transcript-block/clipping-studio-transcript-block.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.transcript-block__textarea::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.transcript-block__textarea::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.transcript-block__textarea::-webkit-scrollbar-corner {
  background: transparent;
}
.transcript-block__textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.transcript-block__textarea::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.transcript-block__textarea::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.transcript-block__textarea::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.transcript-block__textarea::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.transcript-block {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.transcript-block:hover .transcript-block__actions {
  opacity: 1;
}
.transcript-block--editing {
  border-color: rgb(45, 187, 252);
  box-shadow: 0 0 0 2px rgba(45, 187, 252, 0.2);
}
.transcript-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.transcript-block__timestamp {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  font-family: "Open Sans", sans-serif;
}
.transcript-block__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.transcript-block__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 6px;
  height: 22px;
  min-width: 48px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.54);
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
}
.transcript-block__action-btn:focus {
  outline: none;
  box-shadow: none;
}
.transcript-block__action-btn:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.transcript-block__text {
  font-size: 13px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  cursor: text;
  font-family: "Open Sans", sans-serif;
}
.transcript-block__textarea {
  width: 100%;
  min-height: 72px;
  padding: 8px 10px;
  font-size: 13px;
  line-height: 1.5;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.85);
  resize: vertical;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.transcript-block__edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.transcript-block__btn {
  font-size: 12px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.transcript-block__btn--primary {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  border: none;
}
.transcript-block__btn--primary:hover {
  opacity: 0.9;
}
.transcript-block__btn--secondary {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(0, 0, 0, 0.14);
}
.transcript-block__btn--secondary:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
/*# sourceMappingURL=clipping-studio-transcript-block.component.css.map */
